module.exports = __webpack_public_path__ + "img/130.e489efe4.jpg";